import React, { useContext } from 'react';
import './styles.scss';
import { ResetOverlayProps } from './interfaces';
import { ScreenEnum } from '../../enums';
import { useTranslation } from 'react-i18next';
import AppStateContext from '../../AppStateProvider/context';

export default function ResetOverlay(props: ResetOverlayProps) {
	const { dispatch } = useContext(AppStateContext);
	const { t } = useTranslation();

	const clearCaches = async () => {
		if ('caches' in window) {
			const cacheNames = await caches.keys();
			await Promise.all(cacheNames.map(name => caches.delete(name)));
			console.log('All caches cleared');
		}
	};

	return (
		<div className='reset-overlay'>
			<div className='inner'>
				<h3>{t('ResetOverlayHeadline')}</h3>
				<p className='p2'>{t('ResetOverlayText')}</p>
				<div>
					<button
						className='black small'
						onClick={() => props.setResetOverlay(false)}
					>
						{t('ButtonCancel')}
					</button>
					<button
						className='red small'
						onClick={() => {
							props.setResetOverlay(false);
							localStorage.clear();
							clearCaches();
							dispatch({ type: 'SET_SETUP', value: null });
							dispatch({ type: 'SET_PINPAIRING_ACTIVATIONRESPONSE', value: null });
							dispatch({ type: 'SET_PINPAIRING_DEVICECODE', value: null });
							props.setScreen(ScreenEnum.welcome);
						}}
					>
						{t('ResetOverlayReset')}
					</button>
				</div>
			</div>
		</div>
	);
}
